import styles from './styles/Category.module.css';

export const CategorySection = ({ language, categories, onCategorySelect, selectedCategories }) => {
  return (
    <div className={styles.categorySection}>
      <div className={styles.categoryContainer}>
        {categories.map((cat, index) => {
          const isActive = (cat.catNameLng?.catName === 'All' && selectedCategories.length === 0) || selectedCategories.includes(cat.catNameLng?.catName);

          return (
            <button key={index} className={`${styles.categoryButton} ${isActive ? styles.active : ''}`} onClick={() => onCategorySelect(cat.catNameLng?.catName)}>
              {cat.catNameLng?.catName === 'All' ? cat.catNameLng?.catName : cat.catNameLng?.[language === 'eng' ? 'catName' : `catName${language.charAt(0).toUpperCase()}${language.slice(1)}`]}
            </button>
          );
        })}
      </div>
    </div>
  );
};
